import React, { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

function PayDescription() {
  const [activeTab, setActiveTab] = useState(null);

  const handleTabClick = (tab) => {
    // Check if the clicked tab is already active
    if (activeTab === tab) {
      // If it's active, toggle it off
      setActiveTab(null);
    } else {
      // Otherwise, set it as active
      setActiveTab(tab);
    }
  };

  return (
    <div className="pay-description-container">
      <ul className="font-primaryFont tab-menu">
        <li
          className={`dropdown border-b py-1 ${
            activeTab === "pay" ? "openPay" : ""
          }`}
        >
          <p
            className="flex justify-between items-center p-2 text-primary text-sm tracking-wider cursor-pointer dropdown-trigger"
            onClick={() => handleTabClick("pay")}
            aria-haspopup="true"
          >
            EMI / PAY IN 3 OFFERS
            {activeTab === "pay" ? (
              <FiChevronDown className="text-xl" />
            ) : (
              <FiChevronUp className="text-xl" />
            )}
          </p>
          <ul
            className="flex flex-col justify-start items-start gap-2 px-2 font-primaryFont dropdown-content"
            aria-label="submenu"
          >
            <li className="flex pt-4 w-full">
              <p className="flex flex-wrap justify-start items-start gap-2">
                {" "}
                or Pay <b className="text-green-700">₹266</b> and rest later via{" "}
                <img
                  width={120}
                  src="https://websdk-assets.s3.ap-south-1.amazonaws.com/shopify-messaging-app/snitchpay_logo.png"
                  alt=""
                />{" "}
                <img
                  width={20}
                  src="https://websdk-assets.s3.ap-south-1.amazonaws.com/shopify-messaging-app/info-icon.png"
                  alt=""
                />{" "}
              </p>
            </li>
            <li className="flex w-full">
              <p className="flex flex-wrap justify-start items-start gap-1 text-sm">
                or <b>3</b> monthly payments of{" "}
                <b className="text-green-600">₹333</b> with{" "}
                <img
                  width={80}
                  src="https://assets.snapmint.com/assets/express_checkout/SnapMint_logo.svg"
                  alt=""
                />{" "}
                <img
                  src="https://assets.snapmint.com/assets/merchant/info.png"
                  alt=""
                />
              </p>
            </li>
            <li>
              {" "}
              <p className="text-[12px] text-primary">
                UPI & Cards Accepted, Online approval in 2 minutes{" "}
              </p>
            </li>
            <li className="flex pb-4 w-full">
              {" "}
              <p className="flex flex-wrap justify-start items-start gap-1 text-sm">
                {" "}
                Or 3 interest free payments of <b>₹266.34</b>{" "}
                <img
                  width={70}
                  src="https://www.snitch.co.in/cdn/shop/t/316/assets/brand.svg?v=74745334496592893301707102784"
                  alt=""
                />{" "}
              </p>
            </li>
          </ul>
        </li>

        <li
          className={`dropdown border-b py-1  ${
            activeTab === "Description" ? "openDescription" : ""
          }`}
        >
          <p
            className="flex justify-between items-center p-2 text-primary text-sm tracking-wider cursor-pointer dropdown-trigger"
            onClick={() => handleTabClick("Description")}
            aria-haspopup="true"
          >
            DESCRIPTION
            {activeTab === "Description" ? (
              <FiChevronDown className="text-xl" />
            ) : (
              <FiChevronUp className="text-xl" />
            )}
          </p>
          <ul
            className="flex flex-col gap-2 px-2 font-primaryFont dropdown-content"
            aria-label="submenu"
          >
            <li className="flex flex-col pt-4 w-full font-bold text-sm">
              {" "}
              PRODUCT SPECIFICATION
              <ul className="px-6 p-4 text-primary text-sm list-disc">
                <li className="">Short Sleeves</li>
                <li>Printed Deign </li>
                <li>Spread Collar</li>
                <li>Curved Hem Design</li>
                <li>Spare Buttons Included</li>
              </ul>
            </li>
            <p className="flex justify-start items-start gap-2 font-primaryFont text-sm">
              <b>FABRIC:</b> 100% Rayon.{" "}
            </p>
            <p className="flex justify-start items-start gap-2 font-primaryFont text-sm">
              <b>FIT:</b> Slim Fit{" "}
            </p>
            <p className="flex justify-start items-start gap-2 font-primaryFont text-sm">
              <b>SIZE:</b> Model is wearing a M size{" "}
            </p>
            <p className="flex justify-start items-start gap-2 font-primaryFont text-sm">
              <b>Model Height:</b> 6 Feet{" "}
            </p>
            <p className="font-primaryFont text-sm">
              <b className="mr-2">WASH CARE:</b>Cold machine wash. For more
              details see the wash care label attached
            </p>
            <p className="flex justify-start items-start gap-2 pb-4 font-primaryFont font-semibold text-sm">
              Actual colour of the product may vary slightly due to photographic
              lighting sources or your device.
            </p>
          </ul>
        </li>

        <li
          className={`dropdown border-b py-1 ${
            activeTab === "moreInfo" ? "openMoreInfo" : ""
          }`}
        >
          <p
            className="flex justify-between items-center p-2 text-primary text-sm tracking-wider cursor-pointer dropdown-trigger"
            onClick={() => handleTabClick("moreInfo")}
            aria-haspopup="true"
          >
            MORE INFORMATION
            {activeTab === "moreInfo" ? (
              <FiChevronDown className="text-xl" />
            ) : (
              <FiChevronUp className="text-xl" />
            )}
          </p>
          <ul
            className="flex flex-col gap-4 px-2 font-primaryFont text-sm dropdown-content"
            aria-label="submenu"
          >
            <li className="pt-2">
              <b>Manufactured & Marketed by:</b>
            </li>
            <li>
              <b>Snitch Apparels Pvt. Ltd.</b>
              <p className="text-xs">
                No. 1/1, St. Johns Church Road, Bharathinagar, Bengaluru -
                560005
              </p>
            </li>
            <li className="pb-2">
              <b>Country of Origin:</b>
              <p>india</p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

export default PayDescription;

/*<div class="relative font-primaryFont cursor-pointer group">
      <div class="flex justify-between items-center border-y-[1px] bg-white px-4 py-2">
        <a class="lg:mx-4 py-2 font-medium text-base text-primary menu-hover">
          EMI / PAY IN 3 OFFERS
        </a>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
            />
          </svg>
        </span>
      </div>

      <div class="group-hover:visible z-30 absolute flex flex-col justify-start items-start gap-2 bg-gray-100 shadow-xl px-4 py-4 w-full font-primaryFont text-gray-800 invisible">
        <p>
          or Pay ₹333 and rest later via <b>SnitchPay</b>
        </p>
        <p>or 3 monthly payments of ₹333 with snapMint </p>
        <p>UPI & Cards Accepted, Online approval in 2 minutes</p>
        <p>Or 3 interest free payments of ₹333 </p>
      </div>
    </div>
    <div class="relative font-primaryFont cursor-pointer group">
      <div class="flex justify-between items-center border-y-[1px] bg-white px-4 py-2">
        <a class="lg:mx-4 py-2 font-medium text-base text-primary menu-hover">
          DESCRIPTION
        </a>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
            />
          </svg>
        </span>
      </div>

      <div class="group-hover:visible z-30 absolute flex flex-col justify-start items-start gap-2 bg-gray-100 shadow-xl p-4 w-full font-primaryFont text-gray-800 invisible">
        <p className="text-sm">
          Elegant Monotone Maroon Shirt provides a reliable, professional
          look and is designed to be comfortable while wearing. Its
          sophisticated form makes it suitable for a variety of occasions,
          from formal events to party gatherings.
        </p>
        <strong className="text-left">PRODUCT SPECIFICATION</strong>
        <ul className="px-6 py-2 w-full list-disc">
          <li className="">Full Sleeves</li>
          <li>Solid Pattern</li>
          <li>Spread Collar</li>
          <li>Curved Hem Design</li>
          <li>Spare Buttons Included</li>
        </ul>
        <p>
          <b>FABRIC</b>: 100% Cotton
        </p>
        <p>
          <b>FIT</b>: Slim Fit
        </p>
        <p>
          <b>SIZE</b>: Model is wearing a M size{" "}
        </p>
        <p>
          <b>Model Height</b>: 100% Cotton
        </p>
        <p>
          <b>WASH CARE</b>: Cold machine wash. For more details see the
          wash care label attached.
        </p>
        <b className="text-sm">
          Actual colour of the product may vary slightly due to
          photographic lighting sources or your device.
        </b>
      </div>*/
